import { ActionContext } from 'vuex';
import StateType from '@/features/private/integrations/store/state.type';
import { Http } from '@integrai/ui';

export default {
  async getClient(context: ActionContext<StateType, {}>): Promise<void> {
    const { commit } = context || {};

    await Http.get('client')
      .then((client) => commit('setClient', client));
  },
  async sendAccountVerificationEmail(
    context: ActionContext<StateType, {}>,
    id: string,
  ): Promise<void> {
    const { commit } = context || {};

    commit('toggleLoading', true);

    return Http.post('/client/account-verification', { id })
      .then(() => commit('setEmailSent', true))
      .finally(() => commit('toggleLoading', false));
  },
  async searchClient(context: ActionContext<StateType, {}>, query: string): Promise<any> {
    return Http.get('auth/client-search', {
      params: {
        query,
      },
    });
  },
  async loginClient(context: ActionContext<StateType, {}>, id: string): Promise<any> {
    return Http.post('auth/client-login', {
      id,
    });
  },
};
